import { sendToMixpanel } from '..';
import { FAA_LANDING_PAGE_MODULE } from './modules';

const trackGuide = (guideTitle: string): void => {
  sendToMixpanel('Click FAA Landing Page Module', {
    siteSection: 'Agents',
    module: FAA_LANDING_PAGE_MODULE.CONTENT_CAROUSEL_GUIDES,
    guideTitle,
  });
};

export default trackGuide;
